module.exports = __webpack_public_path__ + "static/media/testimonial_bg_shap.87d0684d.png";